import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Register } from '../../_models/register';
import { Caller } from '../../_models/caller';
import { ApiIntegration } from '../../_services/api.integration';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { Globals } from '../../_models/globals';
import { AlertService } from '../../_services/alert.service';

@Component({
  selector: 'app-create-notification',
  templateUrl: './create-notification.component.html',
  styleUrls: ['./create-notification.component.css']
})
export class CreateNotificationComponent implements OnInit {

  description: string = "";
  type: string = "";
  typeStatusText: string = "";
  descStatusText: string = "";
  statusText: string = "";
  notificationId: number = 0;

  constructor(private alertService: AlertService, private http: HttpClient, public router: Router, public route: ActivatedRoute, public register: Register, public caller: Caller, private api: ApiIntegration, public g: Globals) {
    this.g.page = "Create Notification";
  }
  ngOnInit() { }
  clearNotifyDetails() {
    this.description = "";
    this.type = "";
  }
  TypeStatusText() {
    this.typeStatusText = "";
    if (this.type == '' || this.type === null || this.type === undefined || this.type === 'undefined') {
      this.typeStatusText = 'Please enter Notification Type';
    }
  }
  DescStatusText() {
    this.descStatusText = "";
    if (this.description == '' || this.description === null || this.description === undefined || this.description === 'undefined') {
      this.descStatusText = 'Please enter Notification Description';
    }
  }

  submitNotify() {

    this.typeStatusText = "";
    if (this.type == '' || this.type === null || this.type === undefined || this.type === 'undefined') {
      this.typeStatusText = 'Please enter Notification Type';
    }

    this.descStatusText = "";
    if (this.description == '' || this.description === null || this.description === undefined || this.description === 'undefined') {
      this.descStatusText = 'Please enter Notification Description';
    }

    this.statusText = "";
    if (this.typeStatusText != "" || this.descStatusText != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    this.g.loaderDisplay = "display";

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/notifications', {
      "description": this.description,
      "organizationId": 1,
      "status": "ACTIVE",
      "type": this.type
    },
      {
        headers: header1
      }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == '200') {
          this.alertService.success('Notification', 'Created Successfully');
          this.router.navigate(['/admin/notify']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
          this.statusText = "Notification creation Failed, please re-try.";
        }
      );
  }
}
